// removed by extract-text-webpack-plugin
module.exports = {"footer":"_2nhzBA1RlNKOVN_nNggXzW","footer-container":"_3MQhCjFjXLpy1aqGIukLxv","footer-p":"_3hGFNXfe0HOLbBo3i8rNOX","social-container":"_2BD8CatH0lZAsu8yrPX0bp","icon":"_2xMc_cNOvMb7qiE9tyGfDT","wechat-qr":"VdfFMXUa4srdN5O0mpglq","wechat-logo":"_1LKkAPFocPRoDe2wDeeeBz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.scss
// module id = 1157
// module chunks = 47